﻿import {KeysetQuery, KeysetQueryResult, translation} from "@2d-front-monorepo/core";
import {
	KeysetPager,
	Table,
	TableColumn,
	TableColumnType
} from "@2d-front-monorepo/design-library";
import {
	formatCurrency,
	formatDateTimeShort,
	PaymentHistoryEntry,
	Tariffs
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../api-endpoint";
import MaterialIcon from "../../components/MaterialIcon";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {formatRoute} from "../../routes";

interface ReservationInvoicesProps {
	data: KeysetQueryResult<PaymentHistoryEntry>;
	loading: boolean;
	onPageChange: (query: KeysetQuery<number>) => void;
}

export default function ReservationInvoices({data, loading, onPageChange}: ReservationInvoicesProps): JSX.Element {
	const {installation} = getGlobalContext();

	return (
		<div className={loading ? "layout--loading" : undefined}>
			<Table data={data.data} className="table--card">
				<TableColumn<PaymentHistoryEntry, "tariffId">
					title={translation(PermitTranslations.permit_type)}
					property="tariffId"
					surrogate={tariffId => Tariffs.get(installation, tariffId).title}/>

				<TableColumn<PaymentHistoryEntry, "startDate">
					title={translation(PermitTranslations.date)}
					type={TableColumnType.Date}
					property="startDate"
					surrogate={formatDateTimeShort}/>

				<TableColumn<PaymentHistoryEntry, "quotation.price.total">
					title={translation(PermitTranslations.price)}
					type={TableColumnType.Number}
					property="quotation.price.total"
					surrogate={formatCurrency}/>

				<TableColumn<PaymentHistoryEntry, "reservationId">
					title={""}
					type={TableColumnType.Actions}
					property="reservationId"
					render={value => {
						return (<>
							<a href={formatRoute(API_ENDPOINT.reservationInvoice, value.reservationId, installation.id)}
							   target="_blank"
							   download
							   title={translation(PermitTranslations.download)}>
								<MaterialIcon icon="download"/>
							</a>
						</>);
					}}/>
			</Table>

			<KeysetPager keyField={"id"} items={data} onPageChange={onPageChange}/>
		</div>
	);
}
